import { useState } from "react";

function App() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formErrors, setFormErrors] = useState({});

  const rules = {
    email: (value) => {
      if (value.length < 3 || value.length > 12) {
        return "用户名必须大于 3 且小于 12 个字符";
      }
    },
    password: (value) => {
      if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(value)) {
        return "密码必须大于 8 个字符，且至少包含一个字母和数字";
      }
    },
  };

  function handleEmailChange(event) {
    setEmail(event.target.value);
  }
  function handlePasswordChange(event) {
    setPassword(event.target.value);
  }

  function handleInputChange(e) {
    let { value, name, type } = e.target;
  }

  function validateForm(event) {
    event.preventDefault();
  }

  return (
    <main>
      <form>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onInput={handleEmailChange}
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={password}
            onInput={handlePasswordChange}
          />
        </div>
        <button type="submit">Submit</button>
        <button type="reset">Reset</button>
      </form>

      <div>
        <div>Email: {email}</div>
        <div>Password: {password}</div>
      </div>
    </main>
  );
}

export default App;
